import { cn, OverflowText } from "ui";

interface SubheadingProps extends React.HTMLAttributes<HTMLHeadingElement> {}

export function Subheading({ className, ...props }: SubheadingProps) {
  return (
    <OverflowText
      className={cn("mt-1 text-base text-foundations-bold", className)}
      {...props}
    />
  );
}
